/*
<!----------------------------------------------------------------------------------------->
<!----------------------------------------------------------------------------------------->
<!----------------------------------------------------------------------------------------->
  
<!-- NIKOLAJ: START 
  - See the sections/cart-drawer.liquid for HTML code
  - See the layout/theme.liquid for (1) assets/nikolaj-cart-static-products.css code load (2) and JS code 
  - See the assets/nikolaj-cart-static-products.css created by Nikolaj AND for a brief functionality-description of below code.
-->
<script>
*/

  function nikolajStaticTogglePopup( n ) {
    var popup = document.getElementById("nikolaj-static-myPopup"+n);
    popup.classList.toggle("nikolaj-static-show");
  
    // Stop event propagation so click inside doesn't close it
    event.stopPropagation();
  }



  function nikolajPredefinedStoreCurrency( cb ) {
    let currency = window.Shopify.currency.active;
        currency = currency ? currency : "N/A";

    if ( currency === 'DKK' )
      currency = 'kr'
    
    cb( currency );
  }


  function nikolajPredefinedAllCheckboxesDisabled( total, isDisable ) {
     for (let n = 0; n < total; n++) {
        var checkbox = document.getElementById( 'nikolaj-static-addOrderLine'+n );
        if ( checkbox && checkbox.disabled !== isDisable )
          checkbox.disabled = isDisable;
      }
  }

  
  function nikolajPredefinedProductMain( predefinedProductHandle, checkboxTotal, n ) {
    
    ///////////////////////////
    var isTestEnabled = false;
    ///////////////////////////

    var checkboxContainer       = document.getElementById( 'nikolaj-static-predefined-order-line'+n );
    var checkbox                = document.getElementById( 'nikolaj-static-addOrderLine'+n );
    var productInfo             = document.getElementById( 'nikolaj-static-product-info'+n );
    var productPrice            = document.getElementById( 'nikolaj-static-product-price'+n );
       

    // Fetch product data dynamically ( THANKS: https://shopify.dev/docs/api/ajax/reference/product )
    fetch(window.Shopify.routes.root + `products/${predefinedProductHandle}.js`)
      .then(response => {
        
        //if ( isTestEnabled )
          //console.log("nikolaj-static: Response received:", response); // Print the response to console

        if ( response.status === 200 )
          return response.json(); // Return the parsed JSON

        throw new Error(`nikolaj-static: The product ${predefinedProductHandle} does not exists OR is in DRAFT mode. Abort.`);
      })
      .then(product => {
        
        if ( isTestEnabled )
          console.log("nikolaj-static-product-data:", product);
        
        // 0:
        if ( ! window.nikolaj_static_product_data )
          window.nikolaj_static_product_data = {};
        
        window.nikolaj_static_product_data[predefinedProductHandle] = product;        

        // 1: Hide checkbox if product is unavailable
        if (!product.available) {
          checkboxContainer.style.display = 'none';
          return;
        }

        
        nikolajPredefinedStoreCurrency( ( currency ) => {
          
            // 2: Show checkbox if product is available
            if ( ! isTestEnabled )
              checkboxContainer.style.display = 'block';
    
            // 3: Update product info (name & price)
            productInfo.textContent  = product.title;
            productPrice.textContent = (product.variants[0].price / 100).toFixed(2) + " " + currency;
    
            
            // 4: APPROACH 1:
            /*
            function infoWithPopover1( productDescription, n ) {
              const infoIconElem           = document.getElementById('nikolaj-static-infoIcon'+n);
              const productDescriptionElem = document.getElementById('nikolaj-static-productDescription'+n);
    
              productDescriptionElem.innerHTML = productDescription;
              
              // Toggle visibility when clicking the icon
              infoIconElem.addEventListener('click', function () {
                productDescriptionElem.classList.toggle('nikolaj-static-product-description-hidden');
              });          
            }
    
            infoWithPopover1( product.description, n );
            */

            // APPROACH 2:
            /*
            function infoWithPopover2( productDescription, n ) {
              const infoIcon       = document.getElementById('nikolaj-static-infoIcon'+n);
              const popover        = document.getElementById('nikolaj-static-popover'+n);
              const popoverContent = document.getElementById('nikolaj-static-popoverContent'+n);

              if (!infoIcon || !popover || !popoverContent) {
                console.error(`nikolahj-static: Elements for popover ${n} not found`);
                return;
              }
            
              // Set popover content
              popoverContent.textContent = productDescription; // TODO: innerHTML
            
              // Toggle popover visibility when clicking the icon
              infoIcon.addEventListener('click', function (event) {
                popover.classList.toggle('show');
            
                // Position the popover relative to the icon
                const rect = this.getBoundingClientRect();
                popover.style.top = `${rect.bottom + window.scrollY + 5}px`;
                popover.style.left = `${rect.left + window.scrollX}px`;
            
                event.stopPropagation(); // Prevents immediate closing
              });
            
              // Hide popover when clicking outside
              document.addEventListener('click', function (event) {
                if (!popover.contains(event.target) && event.target !== infoIcon) {
                  popover.classList.remove('show');
                }
              });
              
            }
    
            infoWithPopover2( product.description, n );
            */
          
            // APPROACH 3:
          
            function infoWithPopover3( productDescription, n ) {

              var popup          = document.getElementById("nikolaj-static-myPopup"+n);

              if ( ! popup ) {
                console.error(`nikolahj-static: Elements for popover ${n} not found`);
                return;
              }
              
              popup.innerHTML = productDescription;
                            
              // Click outside to close
              document.addEventListener("click", function(event) {
                var popup          = document.getElementById("nikolaj-static-myPopup"+n);
                var popupContainer = document.getElementById("nikolaj-static-popupContainer"+n);
              
                if (!popupContainer.contains(event.target)) {
                  popup.classList.remove("nikolaj-static-show");
                }
              });              
            }
    
            infoWithPopover3( product.description, n );
             
            
            // 5:
            
            var predefinedVariantId = product.variants[0].id;
    
            
            // 4: Check if product is already in the cart ( always called on load, and when checkmark clicked )
            function checkCart( isInit ) {
              fetch( window.Shopify.routes.root + 'cart.js')
                .then(response => response.json())
                .then(data => {
                  let itemExists = data.items.some(item => item.id === predefinedVariantId);
                  checkbox.checked = itemExists;
    
                  if ( itemExists ) {
    
                    ///////////////////////////////// 
                    // 1: Hide the quanity buttons for this line
                    /////////////////////////////////                 
                    
                    // Define the product title to match (e.g., 'Gaveindpakning')
                    const productTitle = product.title;
                  
                    // Function to find the cart item by title and hide the quantity input section
                    function hideQuantitySectionForProduct() {
                      // Loop through all cart items
                      document.querySelectorAll('.cart-item').forEach(cartItem => {
                        // Get the product title from the cart item
                        const titleElement = cartItem.querySelector('.cart-item__title a');
                        if (titleElement && titleElement.textContent.trim() === productTitle) {

                          // 1: Hide the quantity section:
                          
                          // Find the quantity section of the product in the cart
                          const quantitySection = cartItem.querySelector('.quantity.buttoned-input');
                          if (quantitySection) {
                            // Hide the entire quantity input section
                            quantitySection.style.display = 'none'; // You can also use `quantitySection.setAttribute('hidden', 'hidden')` to hide it
                          }

                          // 2: If accessing directly to https://littlenordicnest.dk/cart then also hide this:
                          
                          // Hide the "Fjern" (Remove) link
                          const removeLink = cartItem.querySelector('.cart-item__remove');
                          if (removeLink) {
                              removeLink.style.display = 'none';
                          }
                      
                        }
                      });
                    }
                  
                    // Run the function to hide the quantity section for the matched product
                    hideQuantitySectionForProduct();
                  
                  }

                    ///////////////////////////////// 
                    // 2: Update Cart without refreshing browser
                    ///////////////////////////////// 
    
                    if ( ! isInit ) { // avoid endless loop
                      // OLD: See the refreshCart() method instead of doing this: window.location.reload();
                    }
                });
            }

          
           // 
           // You will see this:

            /**
            * (1) run this: getEventListeners(document); in console
            * (2) You will see these Important Listeners for Cart Updates:
                  on:cart:change → Might be useful for triggering cart updates.
                  dispatch:cart-drawer:refresh → This likely refreshes the cart drawer.
                  booster:cart:update → This might be coming from an app or theme extension.
                  bndlr:bundle_added_to_cart → Likely related to a bundle app.
                  dispatch:cart-drawer:open / dispatch:cart-drawer:close → These manage the cart drawer.
            **/
            function refreshCart( cb ) {
              fetch('/cart.js')
                  .then(response => response.json())
                  .then(cartData => {
                      //console.log("nikolaj-static: addToCart->CartData: ", cartData );

                      document.dispatchEvent(new Event('on:cart:change'));
                      document.dispatchEvent(new Event('dispatch:cart-drawer:refresh')); 

                       setTimeout( () => {
                         cb( cartData );
                       }, 400 );
                  });
            }
    
            
            // 5: Add to cart
            function addToCart( cb ) {
              fetch( window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id:       predefinedVariantId,
                  quantity: 1
                })
              })
              .then(response => response.json())
              .then(data => {
                // 1: Update the cart display
                refreshCart( ( cartData ) => {
                  // 2:
                  checkCart( false );

                  cb();
                })                
              })                
              .catch(error => { 
                cb();
                console.error('nikolaj-static: Error adding item:', error)
              });
            }
            
    
            function getLineItemKeyFromTitle(productTitle, cb ) {
              // Fetch the current cart data
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  // Loop through the cart items and find the item with the matching product title
                  const matchingItem = cart.items.find(item => {
                    // Compare the cart item's title with the provided product title
                    return item.title === productTitle;
                  });
            
                  // If the item is found, return its line item key
                  if (matchingItem) {
                    
                    if ( isTestEnabled )
                      console.log('nikolaj-static: Found matchingItem line:', matchingItem );
                    
                    cb( matchingItem.key );  // Return the line item key 
                  
                  } else {
                    console.error('nikolaj-static: No matching item found in the cart for title:', productTitle);
                  }
                })
                .catch(error => {
                  console.error('nikolaj-static: Error fetching cart data:', error);
                });
            }
            
    
            // 6: Remove from Cart:
            function removeFromCart( productTitle, cb ) {  
              getLineItemKeyFromTitle( productTitle, ( keyId ) => {
    
                if ( ! keyId ) {
                  console.error('nikolaj-static: removeFromCart: Error line id does not exits. Maybe customer did press multiple times?');
                  cb();
                  return;
                }
      
                //console.log("nikolaj-static: removeFromCart: keyId: ", keyId );
                
                fetch( window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id:       keyId, //predefinedVariantId,
                    quantity: 0
                  })
                })
                .then(response => response.json())
                .then(data => {
                  // 1: Update the cart display
                  refreshCart( ( cartData ) => {
                    // 2:
                    checkCart( false );

                    cb();
                  })                
                })             
                .catch(error => {
                    cb();
                    console.error('nikolaj-static: Error removing item:', error);
                });
              });
            }
    
            /////////////
            //// MAIN ///
            /////////////

            /////
            // 1: Add or remove product on checkbox click
            /////
          
            checkbox.addEventListener('change', function () {

              var productTitle = window.nikolaj_static_product_data[predefinedProductHandle].title;
    
              // Disable the checkbox to prevent further changes during the operation
              // NOTE: Since we refresh the website, we don't need to enable it again.
              nikolajPredefinedAllCheckboxesDisabled( checkboxTotal, true );

              setTimeout( () => {
                if ( isTestEnabled )
                console.log("CheckBox Clicked");
              
                if (checkbox.checked) {
                  addToCart(                    () => { nikolajPredefinedAllCheckboxesDisabled( checkboxTotal, false ); });
                } else {
                  removeFromCart( productTitle, () => { nikolajPredefinedAllCheckboxesDisabled( checkboxTotal, false ); });
                }
              }, 0 );
              
            });

            /////
            // 2: On Init:
            /////
          
            checkCart( true ); // Check cart on load
          
          }); // end of currency cb
               
        }).catch(error => console.error('nikolaj-static: Error fetching product:', error));
    
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    let checkboxTotal = 2;
    
    // 1:
    // https://mylittlenordic.dk/products/gave-indpakning
    nikolajPredefinedProductMain( "gave-indpakning", checkboxTotal, 1 );
    
    // 2:
    // https://mylittlenordic.dk/products/ekspress-fremstilling
    nikolajPredefinedProductMain( "ekspress-fremstilling", checkboxTotal, 2 );
  });

/*          
</script>
<!-- NIKOLAJ: END --> 
*/
